import { SignInMessages } from "../react-components/auth/SignInModal";

export default class LockHelper {
  constructor(hubChannel, authChannel, store, performConditionalSignIn) {
    this.hubChannel = hubChannel;
    this.authChannel = authChannel;
    this.store = store;
    this.performConditionalSignIn = performConditionalSignIn;
  }

  async setLocked(el, pin) {
    if (NAF.utils.isMine(el)) {
      this._signInAndLockOrUnlockElement(el, pin);
    } else {
      console.warn("PinningHelper: Attempted to set pin state on object that was not mine.");
    }
  }

  _signInAndLockOrUnlockElement = (el, pin) => {
    const action = pin ? () => this._lockElement(el) : () => this.unlockElement(el);

    this.performConditionalSignIn(
      () => this.hubChannel.signedIn,
      action,
      pin ? SignInMessages.pin : SignInMessages.unpin,
      e => {
        console.warn(`PinningHelper: Conditional sign-in failed. ${e}`);
      }
    );
  };

  async _lockElement(el) {

    try {
      if (!NAF.utils.isMine(el) && !NAF.utils.takeOwnership(el)) {
        console.warn("PinningHelper: Pinning succeeded, but ownership was lost in the mean time");
      }

      el.setAttribute("lockeable", { locked: true });
      el.emit("locked", { el });
    } catch (e) {
      console.warn("LockHelper: Lock failed for unknown reason", e);
    }
  }

  unlockElement(el) {
    const components = el.components;
    const networked = components.networked;

    if (!networked || !networked.data || !NAF.utils.isMine(el)) {
      console.warn("PinningHelper: Tried to unpin element that is not networked or not mine.");
      return;
    }

    el.setAttribute("lockeable", { locked: false });
    el.emit("unlocked", { el });
    el.components.lockeable.update();
  }
}
